
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PreviewJobHeader extends Vue {
  @Prop(Number) public jobId: number;
  @Prop(String) public jobDate: string;
}
